import { render, staticRenderFns } from "./flexbox-item.vue?vue&type=template&id=3d2bb112&"
import script from "./flexbox-item.vue?vue&type=script&lang=js&"
export * from "./flexbox-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports